import { render, staticRenderFns } from "./CargarResultado.vue?vue&type=template&id=7420074b&scoped=true"
import script from "./CargarResultado.vue?vue&type=script&lang=ts"
export * from "./CargarResultado.vue?vue&type=script&lang=ts"
import style0 from "./CargarResultado.vue?vue&type=style&index=0&id=7420074b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7420074b",
  null
  
)

export default component.exports